// Authentication service for handling user authentication
import axios from 'axios';

let API_BASE_URL = '';

// In development, check if window.location contains localhost or 127.0.0.1
if (typeof window !== 'undefined' && 
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    API_BASE_URL = 'http://localhost:8000';
}

/**
 * Log in a user with email and password
 * @param email User's email
 * @param password User's password
 * @returns Promise with login response
 */
export const login = async (email: string, password: string) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/api/auth/login`, {
            email,
            password
        });
        
        if (response.data && response.data.token) {
            localStorage.setItem('auth_token', response.data.token);
            
            // Store user data if available
            if (response.data.user) {
                localStorage.setItem('user', JSON.stringify(response.data.user));
            }
        }
        
        return response.data;
    } catch (error) {
        console.error('Login failed:', error);
        throw error;
    }
};

/**
 * Log out the current user
 * @param redirectTo Optional URL to redirect to after logout
 */
export const logout = (redirectTo = '/login') => {
    // Clear ALL localStorage data completely
    localStorage.clear();

    // Alternative: Remove specific keys if you need to preserve some data
    // Auth keys
    // localStorage.removeItem('auth_token');
    // localStorage.removeItem('user_id');
    // localStorage.removeItem('user_role');
    // localStorage.removeItem('user');
    // localStorage.removeItem('client_id');
    // localStorage.removeItem('token');
    // localStorage.removeItem('guest_token');

    // Impersonation keys
    // localStorage.removeItem('original_token');
    // localStorage.removeItem('original_user_id');
    // localStorage.removeItem('original_user_role');
    // localStorage.removeItem('impersonation_token');
    // localStorage.removeItem('impersonated_user_id');
    // localStorage.removeItem('impersonated_client_id');

    // Data keys
    // localStorage.removeItem('conversation_id');
    // localStorage.removeItem('citations_enabled');
    // localStorage.removeItem('dataImportActiveTab');
    // localStorage.removeItem('themeEditorActiveTab');

    // Crawl keys
    // localStorage.removeItem('crawl_status_noCrawlCache');
    // localStorage.removeItem('crawl_status_history');
    // localStorage.removeItem('activeCrawls');

    // Chat history keys
    // localStorage.removeItem('chat_histories');
    // localStorage.removeItem('demo_conversations');
    // localStorage.removeItem('fallback_messages');

    // Feedback keys (pattern: feedback_*)
    // for (let i = localStorage.length - 1; i >= 0; i--) {
    //     const key = localStorage.key(i);
    //     if (key && key.startsWith('feedback_')) {
    //         localStorage.removeItem(key);
    //     }
    // }

    // Log the logout action
    console.log('[AUTH] User logged out - localStorage cleared');

    // If we're in a browser environment, redirect
    if (typeof window !== 'undefined') {
        // Redirect to the specified path
        window.location.href = redirectTo;
    }
};

/**
 * Check if the user is authenticated
 * @returns Boolean indicating if user is authenticated
 */
export const isAuthenticated = (): boolean => {
    if (typeof window === 'undefined') return false;
    
    const token = localStorage.getItem('auth_token');
    return !!token;
};

/**
 * Get the current user from localStorage
 * @returns User object or null if not logged in
 */
export const getCurrentUser = () => {
    if (typeof window === 'undefined') return null;
    
    const userString = localStorage.getItem('user');
    if (!userString) return null;
    
    try {
        return JSON.parse(userString);
    } catch (e) {
        console.error('[AUTH] Error parsing user data:', e);
        return null;
    }
}; 